export class ListOptions {
  name?: string;
  id!: string;
  options!: Array<string>;
}
